import { useState } from "react";

import { useRouter } from "next/router";

import clearTextSelection from "@/view/utils/clearTextSelection";

const useUpdateLevel = () => {
  const router = useRouter();
  const { query, pathname } = router;
  const { levelId: levelIdQueryParam } = query;

  const [currentLevel, setCurrentLevel] = useState({});

  const handleSetLevel = (level) => {
    const shouldUpdateLevelState = !level.id || level.id !== currentLevel.id;

    // If the level is changed, reset the quiz or power word activity question to 1.
    const shouldResetQuestionQueryParam =
      query.question && query.question !== 1;
    const shouldUpdateLevelIdQueryParam = levelIdQueryParam !== level.id;

    const shouldUpdateQueryParams =
      shouldResetQuestionQueryParam || shouldUpdateLevelIdQueryParam;

    if (shouldUpdateQueryParams) {
      const href = {
        pathname,
        query: {
          ...query,
          ...(shouldResetQuestionQueryParam ? { question: 1 } : {}),
          ...(shouldUpdateLevelIdQueryParam ? { levelId: level?.id } : {}),
        },
      };

      router.replace(href, null, { shallow: true });
    }

    if (shouldUpdateLevelState) {
      // Clear any selected text and the annotations floating button in case they are visible.
      // This prevents the annotation button from persisting on screen when a level changes.
      clearTextSelection();
      setCurrentLevel(level);
    }
  };

  return [currentLevel, handleSetLevel];
};

export default useUpdateLevel;
